import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta":"/sistema/crm/Cliente","alias":["/sistema/crm/Cliente/Index"],"documento":"crm","filas":["128"],"acceso":"sesion","cita":"prod:Areas/CRM/Controllers/ClienteController.cs:29"} satisfies RutaProd;
